const fallbackCopyTextToClipboard = (text: string) => {
  const textArea = document.createElement('textarea')
  textArea.value = text
  textArea.style.top = '0'
  textArea.style.left = '0'
  textArea.style.position = 'fixed'
  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()
  let copied = false
  try {
    copied = document.execCommand('copy')
  } catch {
    copied = false
  }
  document.body.removeChild(textArea)
  return copied
}

export const copyTextToClipboard = async (text: string) => {
  if (!navigator.clipboard) {
    if (!fallbackCopyTextToClipboard(text)) {
      throw new Error('Copy command failed')
    }
    return
  }
  await navigator.clipboard.writeText(text)
}
